module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7z\"></path></svg>"